import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import Dashboard from './Dashboard';
import messages from '../../../locale/jsonMessages';

export default async function action({ store, intl }) {

  const title = intl && intl?.formatMessage(messages.dashboard);
  // From Redux Store
  let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;

  if (!isAdminAuthenticated) {
    return { redirect: '/siteadmin/login' };
  }

  return {
    title,
    chunk: 'adminDashboard',
    component: <AdminLayout><Dashboard title={title} /></AdminLayout>,
  };
};